<template>
  <div class="d-flex align-items-center">
    <!-- Modules Grid Trigger Button -->
    <li class="nav-item nav-icon-item" ref="moduleContainer" v-show="modules && modules.length">
      <a class="nav-link nav-icon-link modules-icon-trigger" @click.stop.prevent="toggleModules" href="javascript:void(0)" title="Modules">
        <img src="/app-assets/images/icons/layout/grid.svg" width="18" height="18" class="ficon" alt="Modules">
      </a>
    </li>

    <!-- Modules Popup -->
    <Teleport to="body">
      <transition name="notif-backdrop">
        <div v-if="showModules" class="modules-backdrop" @click="closeModules"></div>
      </transition>
      <transition name="modules-panel">
        <div v-if="showModules" class="modules-panel text-center" @click.stop>
          <div class="row modules-row">
            <div class="col-md-4 col-sm-4 col-6 text-center modules-col" v-for="(item, i) in modules" :key="i">
              <a class="dropdown-item d-flex justify-content-center flex-column modules-item-link" :href="getModuleUrl(companyId, item)">
                <div><img :src="item.icon" width="40" alt="icons"/></div>
                <div><p class="modules-item-name">{{ item.name }}</p></div>
              </a>
            </div>
          </div>
        </div>
      </transition>
    </Teleport>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';
import handleSidebar from "@/services/modules/sidebar";

export default {
  name: 'ModulesGrid',
  props: {
    modules: {
      type: Array,
      default: () => []
    },
    companyId: {
      type: [String, Number],
      required: true
    }
  },
  setup() {
    const { getModuleUrl } = handleSidebar();
    const showModules = ref(false);
    const moduleContainer = ref(null);

    const toggleModules = () => {
      showModules.value = !showModules.value;
    };

    const closeModules = () => {
      showModules.value = false;
    };

    const handleClickOutside = (event) => {
      if (showModules.value) {
        const panel = document.querySelector('.modules-panel');
        const triggerLi = moduleContainer.value;
        if (
          (!triggerLi || !triggerLi.contains(event.target)) &&
          (!panel || !panel.contains(event.target))
        ) {
          showModules.value = false;
        }
      }
    };

    onMounted(() => {
      document.addEventListener('click', handleClickOutside);
    });

    onUnmounted(() => {
      document.removeEventListener('click', handleClickOutside);
    });

    return { 
      getModuleUrl,
      showModules,
      moduleContainer,
      toggleModules,
      closeModules
    };
  }
};
</script>

<style scoped>
.nav-icon-item { display: flex; align-items: center; }
.nav-icon-link {
  display: flex; align-items: center; justify-content: center;
  width: 38px; height: 38px;
  padding: 0 !important;
  border-radius: 10px;
  color: #6366f1;
  background-color: transparent;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.nav-icon-link:hover {
  background-color: #f3f4f6;
  transform: translateY(-1px);
}
.ficon {
  width: 20px !important;
  height: 20px !important;
  transition: transform 0.2s ease;
}

/* Modules Panel Styling */
.modules-backdrop {
  position: fixed; inset: 0; background: rgba(0,0,0,0.1);
  z-index: 9998;
}
.modules-panel {
  position: fixed; top: 68px; right: 80px;
  width: 26rem; background: #fff; border-radius: 12px;
  box-shadow: 0 12px 48px rgba(0,0,0,0.12), 0 5px 15px rgba(0,0,0,0.08);
  border: 1px solid rgba(0,0,0,0.05);
  z-index: 9999;
  padding: 1.5rem 1rem;
}

.modules-panel-enter-active { transition: opacity 0.22s ease, transform 0.26s cubic-bezier(0.34,1.1,0.64,1); }
.modules-panel-leave-active  { transition: opacity 0.18s ease, transform 0.2s ease; }
.modules-panel-enter-from { opacity: 0; transform: translateY(-10px) scale(0.97); }
.modules-panel-leave-to   { opacity: 0; transform: translateY(-6px)  scale(0.97); }

.modules-row { margin-left: 0; margin-right: 0; }
.modules-col { height: 6.5rem; margin-bottom: 0.5rem; }
.modules-item-link { 
  height: 100%; border-radius: 12px; transition: all 0.2s;
  padding: 1rem 0.5rem !important;
}
.modules-item-link:hover { background-color: #f8f9fa !important; transform: translateY(-2px); }
.modules-item-name { 
  margin-top: 0.75rem; margin-bottom: 0; font-weight: 600; font-size: 0.85rem; color: #4b5563;
}

@media (max-width: 767.98px) {
  .modules-panel { width: 22rem; right: 1rem; top: 60px; }
}
@media (max-width: 575.98px) {
  .modules-panel { width: calc(100vw - 2rem); right: 1rem; }
}
</style>
